import React from "react";
import { useAuth } from "@/context/AuthContext";
import { VLKPageHeader, VLKCard, VLKCardHeader, VLKCardTitle, VLKCardContent, VLKStatusBadge, VLKUserAvatar } from "@/components/vlk";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div>
      <VLKPageHeader title="Settings" description="Your profile and platform preferences." />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <VLKCard>
          <VLKCardHeader><VLKCardTitle>Profile</VLKCardTitle></VLKCardHeader>
          <VLKCardContent>
            <div className="flex items-center gap-4">
              <VLKUserAvatar name={user?.name} src={user?.avatar_url} size={64} />
              <div>
                <div className="font-display text-lg">{user?.name}</div>
                <div className="text-sm text-muted-foreground font-mono">{user?.email}</div>
                <div className="mt-2 flex items-center gap-2">
                  <VLKStatusBadge status="verified">{user?.role}</VLKStatusBadge>
                  <VLKStatusBadge status="active">{user?.auth_method}</VLKStatusBadge>
                </div>
              </div>
            </div>
          </VLKCardContent>
        </VLKCard>

        <VLKCard>
          <VLKCardHeader><VLKCardTitle>Security posture</VLKCardTitle></VLKCardHeader>
          <VLKCardContent>
            <ul className="text-sm space-y-2">
              <li className="flex justify-between"><span>Password hashing</span><span className="font-mono text-xs">bcrypt</span></li>
              <li className="flex justify-between"><span>Session token</span><span className="font-mono text-xs">JWT + httpOnly</span></li>
              <li className="flex justify-between"><span>Refresh rotation</span><span className="text-success text-xs">enabled</span></li>
              <li className="flex justify-between"><span>MFA</span><span className="text-muted-foreground text-xs">planned</span></li>
              <li className="flex justify-between"><span>Passkeys</span><span className="text-muted-foreground text-xs">planned</span></li>
              <li className="flex justify-between"><span>SSO</span><span className="text-muted-foreground text-xs">planned</span></li>
            </ul>
          </VLKCardContent>
        </VLKCard>
      </div>
    </div>
  );
}
